module.exports = __webpack_public_path__ + "img/eyeCrossedOut.13fb3c11.svg";